export default {
  get: () => ['get', '/api/config'],
};
